import { Table } from "@tanstack/react-table"
import { ReactTablePaginationProps } from "../ReactBaseTable"
import { PaginationModel } from "core/sharedmodels/filter/PaginationModel";
import FilterNotation from "core/components/filter/components/filterNotation";

type ReactTableFilterNotationProps <T> = {
  isAsync: boolean;
  table: Table<T>;
  paginationOverride?: ReactTablePaginationProps;
  isLoading?: boolean;
}

export const ReactTableFilterNotation = <T, >({
  isAsync,
  paginationOverride,
  table,
  isLoading
}: ReactTableFilterNotationProps<T>) => {

  const tableState = table.getState();

  const paginationModel = (isAsync && paginationOverride)
    ? new PaginationModel(paginationOverride.pageIndex, paginationOverride.pageLength, paginationOverride.totalRecords, paginationOverride.filteredRecords)
    : new PaginationModel(tableState.pagination.pageIndex + 1, tableState.pagination.pageSize, table.getPreFilteredRowModel().rows.length, table.getPreGroupedRowModel().rows.length);


  return (
    <FilterNotation
        paginationModel={paginationModel}
        filteredRecords={paginationModel.filteredCount ?? 0}
        xOfYisLoading={isLoading}
        hidePaginatedCount={false}
        additionalContainerClasses="d-flex flex-column x-of-y-font-small"
    />
  )
}